<!-- 开始库存盘点计划 / 修改盘点计划 -->
<template>
	<div>
		<subComponents  ref="showSelectData"></subComponents>
		<el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle" :with-header="false" append-to-body center  width="90%" top="1rem">
			<el-form size="mini" label-position="left" label-width="120px" >
				<el-row>
					<el-col :span="12">
						<el-form-item label="单号">
							{{sendDataInfo.ipmId}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="开始时间">
							{{$common.getLocalTime(sendDataInfo.ipmStime)}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="货主">
							{{sendDataInfo.coName}}
						</el-form-item>
					</el-col>
					<el-form-item label="库房">
						{{sendDataInfo.stName}}
					</el-form-item>
				</el-row>
				
			</el-form>
			<el-form size="mini" label-position="top" label-width="120px" >	
				<el-row>
					<el-col :span="24">
						<el-form-item label="实盘人">
							<el-input  @focus="$refs['showSelectData'].openBox('opmList','ipdInverid','pmId')" v-model="sendDataInfo.opmName">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="明细">
					<el-table  :data="sendDataInfo.ipdAiInfos"  border style="width: 100%">
					    <el-table-column  prop="bgmCode" label="商品编号"> </el-table-column>
					    <el-table-column  prop="bgmName" label="通用名称"> </el-table-column>
					    <el-table-column  prop="bgmManufacturer" label="生产厂家"> </el-table-column>
					    <el-table-column  prop="bgmPlaceorigin" label="产地"> </el-table-column>
					    <el-table-column  prop="bgmSpecifications" label="规格"> </el-table-column>
					    <el-table-column  prop="ipdBatnumber" label="批号"> </el-table-column>
					    <el-table-column  prop="ipdTnumber" label="系统库存"> </el-table-column>
					    <el-table-column  prop="ipdAinumber" label="实盘数量"> 
							<template  slot-scope="scope">
								<el-input  v-model="sendDataInfo.ipdAiInfos[scope.$index].ipdAinumber" type="number" min="0"></el-input>
							</template>
						</el-table-column>
					    <el-table-column  prop="ipdOlnumber" label="损溢数量	"> 
							<template  slot-scope="scope">
								<el-input  v-model="sendDataInfo.ipdAiInfos[scope.$index].ipdOlnumber" type="number" min="0"></el-input>
							</template>
						</el-table-column>
					    <el-table-column  prop="ipdRemark" label="盘点备注	"> 
							<template  slot-scope="scope">
								<el-input  v-model="sendDataInfo.ipdAiInfos[scope.$index].ipdRemark" :maxlength="$store.state.inputLength"  ></el-input>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dataActionBox.showStatus = false">取消</el-button>
				<el-button type="primary" @click="sendDataAction">提交信息</el-button>
			</div>
		</el-dialog>
	</div>
	
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
export default {
	name:'startStockLnventoryPlan',
	props:[],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
			dataActionBox:{
				showStatus:false,
				actionType:0, // 0新增，1修改
				boxTitle:'新增'||'编辑',
			},
			sendDataInfo:{
				"ipmId": "",
				"opmName": "",
				coName:"",
				ipmStime: "",
				ipdAiInfos:[],
				ipdInverid:"",
			},
			
        };
    },
    //监听属性 类似于data概念
    computed: {
	},
    //监控data中的数据变化
    watch: {
	},
    //方法集合
    methods: {
	
		async isShowData(name,value){
			switch(name){
				case 'ipdInverid':
					var dataInfo = JSON.parse(sessionStorage.getItem('selectUserData'))
					if(dataInfo){
						this.sendDataInfo.ipdInverid = dataInfo.opmId
						this.sendDataInfo.opmName = dataInfo.opmName
					}
			}
			
		},
	
		
		openBox(cate,oldData=''){
			this.dataActionBox.boxTitle = '库存盘点计划提交审核'
			if(cate==1){
				this.dataActionBox.boxTitle = '修改库存盘点计划'
			}
			this.sendDataInfo.ipmId = oldData.ipmId
			this.sendDataInfo.coName = oldData.coName
			this.sendDataInfo.stName = oldData.stName
			this.sendDataInfo.ipmStime = oldData.ipmStime
			this.sendDataInfo.ipdInverid = oldData.ipdInverid
			this.sendDataInfo.opmName = oldData.ipdInvername
			this.sendDataInfo.ipdAiInfos = oldData.invplanDetailInfos
			
			this.dataActionBox.actionType = cate
			this.dataActionBox.showStatus = true
			
		},
		async sendDataAction(){
			let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
			if(this.dataActionBox.actionType==0){
				var responseData =  await this.$http.submitStockLnventoryPlan(sendData)
			}else{
				var responseData =  await this.$http.setStockLnventoryPlan(sendData)
			}
			
			if(responseData.status == 200){
				this.dataActionBox.showStatus = false
				this.$message({
					message: '操作成功',
					type: 'success'
				});
				
				this.$parent.getDataList()
				
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
	
		
		
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {
	}, //生命周期 - 创建之前
    beforeMount() {
	}, //生命周期 - 挂载之前
    beforeUpdate() {
	}, //生命周期 - 更新之前
    updated() {
	}, //生命周期 - 更新之后
    beforeDestroy() {
	}, //生命周期 - 销毁之前
    destroyed() {
	}, //生命周期 - 销毁完成
    activated() {
	}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
